/**
 * Auto-creates a disabled "Default Routing" conversation_opened workflow when
 * a new integration connects for the first time and the site has no canvas
 * workflows yet. This replaces the old "catch-all rule at the bottom" pattern.
 */
export async function ensureDefaultRoutingWorkflow(
  messagingApi: { get: (path: string) => Promise<Response>; post: (path: string, body: unknown) => Promise<Response> }
): Promise<"created" | "exists" | "error"> {
  try {
    const listResp = await messagingApi.get("Workflows");
    if (!listResp.ok) return "error";

    const workflows = await listResp.json() as Array<{ triggerType: string; isTemplate: boolean }>;
    const hasConvOpened = Array.isArray(workflows) &&
      workflows.some((w) => w.triggerType === "conversation_opened" && !w.isTemplate);

    if (hasConvOpened) return "exists";

    const createResp = await messagingApi.post("Workflows", {
      trigger: "conversation_opened",
      name: "Default Routing",
      enabled: false,
    });

    return createResp.ok ? "created" : "error";
  } catch {
    return "error";
  }
}
